export enum ErrorText {
  woopValidatorErrorText = "Must be a digit 1 to 9",
  overnightIndicatorValidator = "Must be a digit 0 to 9",
  mtowValidation = "Must be a number 0 to 9999999",
  operatorValidatorErrorText = "Must be two letters or digits, optionally followed by a third letter",
  doopValidatorErrorText = "Must be 1234567, 0034067, or 3467",
  IATAAircraftTypeValidatorErrorText = "Must be three letters or digits",
  ICAOAircraftTypeValidatorErrorText = "Must be two to four letters or digits",
  aircraftRegErrorText = "Must be letters or digits",
  aircraftRegSearchErrorText = "Must be letters, digits or wildcards (?, *)",
  slotIdErrorText = "Must be letters, digits or wildcards (?, *)",
  serviceNoErrorText = "Must be one to four digits optionally followed by a letter",
  serviceNoSearchErrorText = "Must be one to four digits optionally followed by a letter, possibly including wildcards (?, *)",
  seatsValidatorErrorText = " Must be a number 0 to 999",
  IATAStationFormat = "Must be three letters",
  ICAOStationFormat = "Must be three or four letters or digits",
  CountryCodeFormat = "Country code is two letters",
  minGroundTimerValidatorRegex = "Must be a number 0 to 9999",
  timeValidatorRegex = "Must be HHMM, 0000 to 2359",
  operatorTextValidation = "Must be letters, digits or space",
  noDate = "Please select a date",
  uniqueErrorText = "Must not be selected twice",
  searchTimeRangeErrorText = "Both fields must be filled out", // KT: Apparently not in use, open range is valid, and works
  timeRangeErrorText = "Start time must not be after end time",
  airportIsLocked = "currently locked. Please try later or contact us.",
  airportIsDisabled = "currently disabled. Please try later or contact us.",
  airportLockedOrDisabled = "currently locked or disabled. Please try later or contact us.",
  airportnotSupportDownload = " support download, and ",
  isDisabled = "is disabled",
  noCommonOperator = "No common operators for selected airports",
  noSingleCommonOperator = "No operators for selected airport",
  reqDateError = "Both Req Date and Reg Time must be filled out"
}

export enum CommonErrorText {
  usernameError = "Please enter a username",
  passworderror = "Please enter a password",
  noEmptyValue = "Value must not be empty",
  invalid = "Invalid code",
  startdateGreater = "Start date must not be after end date",
  departureDateGreater = "Must be on or after arrival date",
  nineDaysDateGreater = "Must be no more than 9 days after arrival date"
}
